module.exports = __webpack_public_path__ + "static/media/slide2Inactive.61c850f2.png";